import React from "react";
import { MetricGrid, PageIntro, SectionCard } from "../../components/goldbot/GoldBotCards";
import GoldBotEquityCurve from "../../components/goldbot/GoldBotEquityCurve";
import {
  buildEquityCurve,
  buildPerformanceMetrics,
  getEquityEmptyMessage,
  getPerformanceState,
} from "../../components/goldbot/goldBotPerformanceViewModel";
import { useGoldBotPerformance } from "../../hooks/useGoldBotPerformance";

function GoldBotPerformance() {
  const { data, error, isLoading } = useGoldBotPerformance();
  const performance = error ? null : data;
  const state = getPerformanceState({ data, error, isLoading });
  const metrics = buildPerformanceMetrics(performance);
  const curve = buildEquityCurve(performance);

  return (
    <>
      <PageIntro eyebrow="Trading results" title="Performance" description="Track GoldBot outcomes across key time periods and risk metrics." />
      <SectionCard title="Performance Summary" eyebrow={state.eyebrow}>
        <MetricGrid items={metrics} className="goldbot-metric-grid--performance-page" />
      </SectionCard>
      <SectionCard
        title="Equity Curve"
        eyebrow={curve.basisLabel || "Since live tracking began"}
      >
        <GoldBotEquityCurve
          curve={curve}
          emptyMessage={state.message || getEquityEmptyMessage(performance)}
        />
      </SectionCard>
    </>
  );
}

export default GoldBotPerformance;
